import { Box, CircularProgress, Dialog, DialogActions, DialogContent, Typography } from "@mui/material"
import type { FC } from "react"

import { useHistoricPurchaseCosts } from "../../hooks/useHistoricPurchaseCosts"
import { PurchaseCostPackageLabel } from "../../types"

import { PurchaseCostPackageCard } from "./PurchaseCostPackageCard"

import { Button } from "@/components/common/Button"
import DialogHeader from "@/components/common/Modals/DialogHeader"

interface PurchaseCostHistoryDialogProps {
  productId: number
  warehouseAreaId: string
  onClose: () => void
}

export const PurchaseCostHistoryDialog: FC<PurchaseCostHistoryDialogProps> = ({
  productId,
  warehouseAreaId,
  onClose,
}) => {
  const { entries, isFetching } = useHistoricPurchaseCosts({ productId, warehouseAreaId })

  const hasEntries = entries.length > 0

  return (
    <Dialog open onClose={onClose} maxWidth='sm' fullWidth data-testid='product.purchase-costs.history-dialog'>
      <DialogHeader title='Historical Pricing' onClose={onClose} />
      <DialogContent>
        {isFetching ? (
          <Box className='flex justify-center py-8'>
            <CircularProgress />
          </Box>
        ) : hasEntries ? (
          <Box className='flex flex-col gap-y-6'>
            {entries.map((entry, index) => (
              <PurchaseCostPackageCard
                key={`${entry.effectiveDate}-${index}`}
                package={entry}
                label={PurchaseCostPackageLabel.Historic}
                testIdPrefix='product.purchase-costs.history-card'
              />
            ))}
          </Box>
        ) : (
          <Typography variant='body2' className='py-6 text-center text-gray-700'>
            No historical pricing found for this warehouse.
          </Typography>
        )}
      </DialogContent>
      <DialogActions className='px-6 pb-6 pt-4'>
        <Button
          appearance='contained'
          onClick={onClose}
          data-testid='product.purchase-costs.history-dialog.close-button'
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  )
}
